import React, { FunctionComponent } from 'react';
import { makeStyles, Alert, AlertTitle } from '@rbx/ui';
import StandardMarkdownNoMargin from '../../markdown/components/StandardMarkdownNoMargin';
import { StandardMarkdownProps } from '../../markdown/components/StandardMarkdown';
import MarkdownProvider from '../../markdown/components/MarkdownProvider';

const useStyles = makeStyles()((theme) => ({
  inlineCode: {
    backgroundColor: theme.palette.action.selected,
  },
}));

interface AlertMarkdownProps extends StandardMarkdownProps {
  className?: string;
  title?: string;
}

const AlertMarkdown: FunctionComponent<React.PropsWithChildren<AlertMarkdownProps>> = ({
  children,
  className,
  title,
}) => {
  const {
    classes: { inlineCode },
  } = useStyles();

  return (
    <Alert className={className} severity='error'>
      {title && <AlertTitle>{title}</AlertTitle>}
      <MarkdownProvider classes={{ inlineCode }}>
        <StandardMarkdownNoMargin>{children}</StandardMarkdownNoMargin>
      </MarkdownProvider>
    </Alert>
  );
};

export default AlertMarkdown;
